import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { service_url } from "./service-url";

@Injectable({
  providedIn: 'root'
})
export class DoctorPatientService {
  api_url: any
  constructor(private http: HttpClient) {
    this.api_url = service_url.api_url
  }

  getDoctorPatients(filters = {}) {
    let params = new HttpParams();
    Object.keys(filters).forEach(function (key) {
      params = params.append(key, filters[key]);
    });
    return this.http.get(this.api_url + '/doctor_patients', { params: params })
  }

  showDoctorPatient(doctor_patient_id) {
    return this.http.get(this.api_url + '/doctor_patients/' + doctor_patient_id)
  }

  submitDoctorPatient(params, id = '') {
    if (id != '') {
      return this.http.put(this.api_url + '/doctor_patients/' + id, { doctor_patient: params })
    }
    else {
      return this.http.post(this.api_url + '/doctor_patients', { doctor_patient: params })
    }
  }

  deleteDoctorPatient(doctor_patient_id) {
    return this.http.delete(this.api_url + '/doctor_patients/' + doctor_patient_id)
  }
}
